<template>
  <div class="box mt-3 p-4 has-background-white animate__animated animate__fadeIn">
    <div class="field">
      <label class="label">Titolo Sezione</label>
      <div class="control">
        <input class="input" type="text" v-model="sezioneLocale.titolo" @change="emettiAggiornamento" placeholder="Lascia vuoto per unire visivamente questa sezione alla precedente">
      </div>
    </div>

    <!-- Impostazioni Logiche della Sezione -->
    <div class="columns mb-4">
      <div class="column is-6">
        <div class="box has-background-light">
          <h4 class="title is-6 mb-2"><span class="icon"><i class="fas fa-eye"></i></span> Visibilità Sezione</h4>
          <div class="field">
            <div class="control">
              <label class="radio">
                <input type="radio" :value="false" v-model="sezioneLocale.condizioneAttivazione.abilitata" @change="emettiAggiornamento">
                Sempre visibile
              </label>
              <br>
              <label class="radio mt-2">
                <input type="radio" :value="true" v-model="sezioneLocale.condizioneAttivazione.abilitata" @change="emettiAggiornamento">
                Mostra solo se un campo precedente è selezionato
              </label>
            </div>
          </div>
            <div class="field mt-3" v-if="sezioneLocale.condizioneAttivazione.abilitata">
              <label class="label is-small">Scegli il campo attivatore</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="sezioneLocale.condizioneAttivazione.campoId" @change="emettiAggiornamento">
                    <option value="" disabled>Seleziona un campo...</option>
                    <option v-for="c in campiPrecedenti" :key="c.id" :value="c.id">
                      {{ c.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="mt-2" v-if="campoAttivatoreSelezionato && campoAttivatoreSelezionato.tipo === 'checkbox_multiplo'">
                 <label class="label is-small">Scegli la voce specifica (Opzionale)</label>
                 <div class="control">
                   <div class="select is-small is-fullwidth">
                     <select v-model="sezioneLocale.condizioneAttivazione.opzioneSelezionata" @change="emettiAggiornamento">
                       <option value="">Qualsiasi voce</option>
                       <option v-for="opt in opzioniCampoAttivatore" :key="opt" :value="opt">
                         {{ opt }}
                       </option>
                     </select>
                   </div>
                 </div>
              </div>
            </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="box has-background-light">
          <h4 class="title is-6 mb-2"><span class="icon"><i class="fas fa-clone"></i></span> Ripetibilità (Ricorsione)</h4>
          <div class="field">
            <div class="control">
              <label class="radio">
                <input type="radio" :value="false" v-model="sezioneLocale.ripetibile.abilitata" @change="emettiAggiornamento">
                Sezione statica (singola)
              </label>
              <br>
              <label class="radio mt-2">
                <input type="radio" :value="true" v-model="sezioneLocale.ripetibile.abilitata" @change="emettiAggiornamento">
                Ripetibile dal cliente
              </label>
            </div>
          </div>
            <div class="field mt-3" v-if="sezioneLocale.ripetibile.abilitata">
              <label class="label is-small">Scegli il campo trigger interno (Checkbox/Radio)</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="sezioneLocale.ripetibile.campoId" @change="emettiAggiornamento">
                    <option value="" disabled>Seleziona un campo...</option>
                    <option v-for="c in campiCheckboxInterni" :key="c.id" :value="c.id">
                      {{ c.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="mt-2" v-if="campoRipetibileSelezionato && campoRipetibileSelezionato.tipo === 'checkbox_multiplo'">
                 <label class="label is-small">Scegli la voce specifica (Opzionale)</label>
                 <div class="control">
                   <div class="select is-small is-fullwidth">
                     <select v-model="sezioneLocale.ripetibile.opzioneSelezionata" @change="emettiAggiornamento">
                       <option value="">Qualsiasi voce</option>
                       <option v-for="opt in opzioniCampoRipetibile" :key="opt" :value="opt">
                         {{ opt }}
                       </option>
                     </select>
                   </div>
                 </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <!-- Domande e Documenti del Questionario -->
    <div class="columns">
      <div class="column is-12">
        <h3 class="title is-6 has-text-grey-dark mb-2">Domande del Questionario</h3>
        <div v-for="(item, idx) in campiOrdinati" :key="item.nome" class="box p-3 mb-2 has-background-white-ter animate__animated animate__fadeIn">
          <div class="is-flex is-justify-content-space-between is-align-items-center mb-2">
            <span class="tag is-info is-light is-small">{{ getNomeTipoCampo(item.campo.tipo) }}</span>
          </div>

          <div class="field mb-2">
            <label class="label is-small">Etichetta visualizzata</label>
            <div class="control">
              <input class="input is-small" type="text" :value="item.campo.label !== undefined && item.campo.label !== '' ? item.campo.label : formattaNomeCampo(item.nome)" @input="aggiornaLabelCampo(item.nome, $event.target.value)">
            </div>
          </div>
          
          <!-- Impostazioni specifiche per 'stringa' e 'note' -->
          <div class="columns is-mobile is-multiline mb-2" v-if="!item.campo.tipo || item.campo.tipo === 'stringa' || item.campo.tipo === 'note'">
            <div class="column is-6 py-1">
              <div class="field">
                <label class="label is-small has-text-grey">Min Caratteri</label>
                <div class="control">
                  <input class="input is-small" type="number" v-model.number="item.campo.minLength" min="0" @change="emettiAggiornamento" placeholder="Nessuno">
                </div>
              </div>
            </div>
            <div class="column is-6 py-1">
              <div class="field">
                <label class="label is-small has-text-grey">Max Caratteri</label>
                <div class="control">
                  <input class="input is-small" type="number" v-model.number="item.campo.maxLength" min="0" @change="emettiAggiornamento" placeholder="Nessuno">
                </div>
              </div>
            </div>
          </div>
          
          <!-- Impostazioni specifiche per 'checkbox_multiplo' -->
          <div class="field mb-2" v-if="item.campo.tipo === 'checkbox_multiplo'">
            <div class="control mb-2">
              <label class="checkbox is-size-7">
                <input type="checkbox" v-model="item.campo.isRadio" @change="emettiAggiornamento"> Singola Scelta (Radio Button)
              </label>
            </div>
            <label class="label is-small has-text-grey">Opzioni (una per riga)</label>
            <div class="control">
              <textarea class="textarea is-small" v-model="item.campo.opzioniStr" @change="emettiAggiornamento" placeholder="Opzione 1&#10;Opzione 2&#10;Opzione 3" rows="3"></textarea>
            </div>
          </div>

          <!-- Testo informativa per accettazione -->
          <div class="field mb-2" v-if="item.campo.tipo === 'accettazione'">
            <label class="label is-small has-text-grey">Regola di accettazione</label>
            <div class="control mb-2">
              <div class="select is-small">
                <select v-model="item.campo.regolaAccettazione" @change="emettiAggiornamento">
                  <option value="facoltativo">Facoltativo (Libero di rispondere o meno)</option>
                  <option value="scelta_obbligatoria">Scelta obbligatoria (Deve rispondere, può accettare o rifiutare)</option>
                  <option value="accettazione_obbligatoria">Accettazione obbligatoria (Deve accettare per proseguire)</option>
                </select>
              </div>
            </div>
            <label class="label is-small has-text-grey">Testo Informativa</label>
            <div class="control">
              <textarea class="textarea is-small" v-model="item.campo.testoInformativa" @change="emettiAggiornamento" placeholder="Inserisci il testo dell'informativa..." rows="3"></textarea>
            </div>
          </div>

          <!-- File precompilato allegato per tipo 'file' -->
          <div class="field mb-2" v-if="item.campo.tipo === 'file' && item.campo.url">
            <label class="label is-small has-text-grey">File precompilato allegato</label>
            <div class="is-flex is-align-items-center">
              <a :href="item.campo.url" target="_blank" class="tag is-link is-light is-small mr-2">Visualizza file</a>
              <button class="button is-small is-ghost is-size-7 p-0 has-text-danger" @click="item.campo.url = null; item.campo.txt = ''; emettiAggiornamento();">Rimuovi allegato</button>
            </div>
          </div>

          <!-- Valore precompilato per campi standard (non indirizzo, non accettazione, non file) -->
          <div class="field mb-2" v-if="item.campo.tipo !== 'indirizzo' && item.campo.tipo !== 'accettazione' && item.campo.tipo !== 'file'">
            <label class="label is-small has-text-grey">Valore precompilato <span v-if="item.campo.tipo === 'checkbox_multiplo'">(Numeri virgola, es: 1,3)</span></label>
            <div class="control">
              <input 
                class="input is-small" 
                :type="item.campo.tipo === 'data' ? 'date' : 'text'" 
                v-model="item.campo.txt" 
                :style="item.campo.tipo === 'cf' || item.campo.tipo === 'iban' ? 'text-transform: uppercase;' : ''"
                :maxlength="item.campo.tipo === 'cf' ? 16 : (item.campo.tipo === 'iban' ? 42 : null)"
                @input="if (item.campo.tipo === 'cf' && item.campo.txt) item.campo.txt = item.campo.txt.toUpperCase().replace(/[^A-Z0-9]/g, ''); else if (item.campo.tipo === 'iban' && item.campo.txt) item.campo.txt = item.campo.txt.toUpperCase().replace(/[^A-Z0-9 ]/g, ''); emettiAggiornamento();" 
                @blur="if (item.campo.tipo === 'iban' && item.campo.txt) { const c = item.campo.txt.replace(/\s+/g, '').toUpperCase(); if (c.length > 0) item.campo.txt = c.replace(/(.{4})/g, '$1 ').trim(); emettiAggiornamento(); }"
                placeholder="Valore precompilato"
              >
            </div>
          </div>
          
          <div class="is-flex is-align-items-center is-justify-content-space-between is-flex-wrap-wrap" style="gap: 0.5rem;">
            <div class="field mb-0" v-if="item.campo.tipo !== 'accettazione'">
              <div class="control">
                <div class="select is-small">
                  <select 
                    :value="item.campo.tipoObbligo || (item.campo.obbligatorio ? 'assoluto' : 'nessuno')" 
                    @change="cambiaTipoObbligo(idx, $event.target.value)"
                  >
                    <option value="nessuno" :disabled="isPrecedenteAlternativo(idx)">Non obbligatorio</option>
                    <option value="assoluto">Obbligatorio</option>
                    <option value="alternativo" v-if="idx < campiOrdinati.length - 1">Obblig. in alternativa al seguente</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-else></div> <!-- spacer per mantenere il layout flex -->
            <div class="buttons are-small mb-0">
              <button class="button is-light" @click="spostaCampo(idx, -1)" :disabled="idx === 0">
                <span class="icon is-small"><i class="fas fa-arrow-up"></i></span>
              </button>
              <button class="button is-light" @click="spostaCampo(idx, 1)" :disabled="idx === campiOrdinati.length - 1">
                <span class="icon is-small"><i class="fas fa-arrow-down"></i></span>
              </button>
              <button class="button is-danger is-light ml-2" @click="rimuoviCampo(item.nome)">Elimina</button>
            </div>
          </div>
        </div>
        
        <div class="field mt-3">
          <label class="label is-small">Aggiungi nuova domanda</label>
          <div class="field has-addons">
            <div class="control">
              <span class="select is-small">
                <select v-model="nuovoCampoTipo">
                  <option value="stringa">Testo Corto</option>
                  <option value="note">Note (Testo Lungo)</option>
                  <option value="email">Email</option>
                  <option value="telefono">Telefono</option>
                  <option value="cf">Codice Fiscale</option>
                  <option value="piva">Partita IVA</option>
                  <option value="iban">IBAN</option>
                  <option value="accettazione">Accettazione condizioni</option>
                  <option value="checkbox_multiplo">Checkbox (Scelta Multipla)</option>
                  <option value="data">Data (Calendario)</option>
                  <option value="indirizzo">Indirizzo Completo</option>
                  <option value="file">Documento da Caricare</option>
                </select>
              </span>
            </div>
            <div class="control is-expanded">
              <input class="input is-small" type="text" v-model="nuovoCampoNome" placeholder="Titolo/Etichetta">
            </div>
            <div class="control">
              <button class="button is-small is-primary" @click="aggiungiCampo">Aggiungi</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
    default: () => ({ 
      titolo: '', 
      campi: {}, 
      condizioneAttivazione: { abilitata: false, campoId: '', opzioneSelezionata: '' }, 
      ripetibile: { abilitata: false, campoId: '', opzioneSelezionata: '' } 
    })
  },
  campiPrecedenti: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:modelValue', 'change']);

// Copia locale per binding
const sezioneLocale = ref(JSON.parse(JSON.stringify(props.modelValue)));

// UI per i nuovi inserimenti
const nuovoCampoNome = ref('');
const nuovoCampoTipo = ref('stringa');

const formattaNomeCampo = (str) => {
  if (!str) return '';
  const result = str.replace(/([A-Z])/g, " $1");
  return (result.charAt(0).toUpperCase() + result.slice(1)).trim();
};

const getNomeTipoCampo = (tipo) => {
  switch (tipo) {
    case 'email': return 'Email';
    case 'telefono': return 'Telefono';
    case 'cf': return 'Codice Fiscale';
    case 'piva': return 'Partita IVA';
    case 'iban': return 'IBAN';
    case 'note': return 'Note (Testo Lungo)';
    case 'accettazione': return 'Accettazione';
    case 'checkbox_multiplo': return 'Scelta Multipla';
    case 'data': return 'Data (Calendario)';
    case 'indirizzo': return 'Indirizzo Completo';
    case 'file': return 'Documento da Caricare';
    case 'stringa':
    default:
      return 'Testo Corto';
  }
};

const campiCheckboxInterni = computed(() => {
  const list = [];
  if (sezioneLocale.value.campi) {
    for (const [key, value] of Object.entries(sezioneLocale.value.campi)) {
      if (value.tipo === 'checkbox_multiplo' || value.tipo === 'accettazione') {
        list.push({ 
          id: key, 
          label: value.label || key,
          tipo: value.tipo,
          opzioniStr: value.opzioniStr || ''
        });
      }
    }
  }
  return list;
});

const campiOrdinati = computed(() => {
  if (!sezioneLocale.value.campi) return [];
  const list = Object.entries(sezioneLocale.value.campi).map(([nome, campo], idx) => ({
    nome,
    campo,
    ordine: campo.ordine !== undefined ? campo.ordine : idx
  }));
  return list.sort((a, b) => a.ordine - b.ordine);
});

const campoAttivatoreSelezionato = computed(() => {
  if (!sezioneLocale.value.condizioneAttivazione?.campoId) return null;
  return props.campiPrecedenti.find(c => c.id === sezioneLocale.value.condizioneAttivazione.campoId);
});

const opzioniCampoAttivatore = computed(() => {
  if (!campoAttivatoreSelezionato.value) return [];
  return (campoAttivatoreSelezionato.value.opzioniStr || '').split('\n').map(o => o.trim()).filter(o => o);
});

const campoRipetibileSelezionato = computed(() => {
  if (!sezioneLocale.value.ripetibile?.campoId) return null;
  return campiCheckboxInterni.value.find(c => c.id === sezioneLocale.value.ripetibile.campoId);
});

const opzioniCampoRipetibile = computed(() => {
  if (!campoRipetibileSelezionato.value) return [];
  return (campoRipetibileSelezionato.value.opzioniStr || '').split('\n').map(o => o.trim()).filter(o => o);
});

const isPrecedenteAlternativo = (idx) => {
  if (idx <= 0) return false;
  const arr = campiOrdinati.value;
  const prec = arr[idx - 1];
  return prec && prec.campo.tipoObbligo === 'alternativo';
};

const normalizzaTipiObbligo = () => {
  const arr = campiOrdinati.value;
  if (!arr || arr.length === 0) return;

  // Se l'ultimo campo è 'alternativo', degrada a 'assoluto'
  const ultimo = arr[arr.length - 1];
  if (ultimo && ultimo.campo.tipoObbligo === 'alternativo') {
    ultimo.campo.tipoObbligo = 'assoluto';
    ultimo.campo.obbligatorio = true;
  }

  for (let i = 0; i < arr.length; i++) {
    const curr = arr[i].campo;
    if (!curr.tipoObbligo) {
      curr.tipoObbligo = curr.obbligatorio ? 'assoluto' : 'nessuno';
    }
    if (i > 0) {
      const prec = arr[i - 1].campo;
      if (prec.tipoObbligo === 'alternativo' && curr.tipoObbligo === 'nessuno') {
        curr.tipoObbligo = 'assoluto';
        curr.obbligatorio = true;
      }
    }
    curr.obbligatorio = (curr.tipoObbligo !== 'nessuno');
  }
};

const emettiAggiornamento = () => {
  // Pulisci opzioneSelezionata se il campo attivatore cambia o viene disabilitato
  if (!sezioneLocale.value.condizioneAttivazione?.abilitata || !campoAttivatoreSelezionato.value || campoAttivatoreSelezionato.value.tipo !== 'checkbox_multiplo') {
     if (sezioneLocale.value.condizioneAttivazione) {
       sezioneLocale.value.condizioneAttivazione.opzioneSelezionata = '';
     }
  }
  // Stessa cosa per la sezione ricorsiva
  if (!sezioneLocale.value.ripetibile?.abilitata || !campoRipetibileSelezionato.value || campoRipetibileSelezionato.value.tipo !== 'checkbox_multiplo') {
     if (sezioneLocale.value.ripetibile) {
       sezioneLocale.value.ripetibile.opzioneSelezionata = '';
     }
  }
  emit('update:modelValue', sezioneLocale.value);
  emit('change', sezioneLocale.value);
};

const cambiaTipoObbligo = (idx, nuovoVal) => {
  const arr = campiOrdinati.value;
  if (!arr[idx]) return;
  const item = arr[idx];
  item.campo.tipoObbligo = nuovoVal;
  item.campo.obbligatorio = (nuovoVal !== 'nessuno');

  if (nuovoVal === 'alternativo' && idx < arr.length - 1) {
    const succ = arr[idx + 1];
    if (succ && (!succ.campo.tipoObbligo || succ.campo.tipoObbligo === 'nessuno')) {
      succ.campo.tipoObbligo = 'assoluto';
      succ.campo.obbligatorio = true;
    }
  }

  normalizzaTipiObbligo();
  emettiAggiornamento();
};

const aggiornaLabelCampo = (nome, val) => {
  if (sezioneLocale.value.campi && sezioneLocale.value.campi[nome]) {
    sezioneLocale.value.campi[nome].label = val;
    emettiAggiornamento();
  }
};

const aggiungiCampo = () => {
  const label = nuovoCampoNome.value.trim();
  if (label) {
    if (!sezioneLocale.value.campi) sezioneLocale.value.campi = {};
    const key = 'campo_' + Date.now();
    const count = campiOrdinati.value.length;
    const ultimoPrec = count > 0 ? campiOrdinati.value[count - 1] : null;
    const tipoObbligoDefault = (ultimoPrec && ultimoPrec.campo.tipoObbligo === 'alternativo') ? 'assoluto' : 'nessuno';

    const nuovoCampo = {
      obbligatorio: tipoObbligoDefault !== 'nessuno',
      tipoObbligo: tipoObbligoDefault,
      txt: '',
      label: label,
      tipo: nuovoCampoTipo.value,
      minLength: null,
      maxLength: null,
      ordine: count
    };
    
    if (nuovoCampo.tipo === 'accettazione') {
      nuovoCampo.txt = '';
      nuovoCampo.testoInformativa = '';
      nuovoCampo.regolaAccettazione = 'accettazione_obbligatoria';
    } else if (nuovoCampo.tipo === 'checkbox_multiplo') {
      nuovoCampo.txt = '';
      nuovoCampo.opzioniStr = '';
      nuovoCampo.isRadio = false;
    } else if (nuovoCampo.tipo === 'indirizzo') {
      nuovoCampo.txt = { via: '', cap: '', citta: '', prov: '' };
    } else if (nuovoCampo.tipo === 'file') {
      nuovoCampo.url = null;
      nuovoCampo.txt = '';
    }

    sezioneLocale.value.campi[key] = nuovoCampo;
    normalizzaTipiObbligo();
    emettiAggiornamento();
    nuovoCampoNome.value = '';
  }
};

const spostaCampo = (idx, dir) => {
  const arr = campiOrdinati.value;
  const targetIdx = idx + dir;
  if (targetIdx < 0 || targetIdx >= arr.length) return;

  // Normalizza gli ordini correnti per evitare duplicati causati da rimozioni
  arr.forEach((item, i) => {
    sezioneLocale.value.campi[item.nome].ordine = i;
  });

  // Scambia gli indici
  sezioneLocale.value.campi[arr[idx].nome].ordine = targetIdx;
  sezioneLocale.value.campi[arr[targetIdx].nome].ordine = idx;

  normalizzaTipiObbligo();
  emettiAggiornamento();
};

const rimuoviCampo = (nomeCampo) => {
  if (sezioneLocale.value.campi && sezioneLocale.value.campi[nomeCampo]) {
    delete sezioneLocale.value.campi[nomeCampo];
    // Re-normalizza gli ordini rimanenti
    campiOrdinati.value.forEach((item, idx) => {
      sezioneLocale.value.campi[item.nome].ordine = idx;
    });
    normalizzaTipiObbligo();
    emettiAggiornamento();
  }
};

watch(() => props.modelValue, (newVal) => {
  sezioneLocale.value = JSON.parse(JSON.stringify(newVal));
  if (!sezioneLocale.value.condizioneAttivazione) {
    sezioneLocale.value.condizioneAttivazione = { abilitata: false, campoId: '' };
  }
  if (!sezioneLocale.value.ripetibile) {
    sezioneLocale.value.ripetibile = { abilitata: false, campoId: '' };
  }
  
  // Auto-migrazione vecchi documenti (sez.file -> sez.campi con tipo: 'file')
  if (sezioneLocale.value.file && Object.keys(sezioneLocale.value.file).length > 0) {
    if (!sezioneLocale.value.campi) sezioneLocale.value.campi = {};
    const maxOrder = Object.values(sezioneLocale.value.campi).reduce((max, c) => Math.max(max, c.ordine ?? 0), -1);
    let offset = 1;
    for (const [fKey, fVal] of Object.entries(sezioneLocale.value.file)) {
      const newKey = fKey.startsWith('campo_') ? fKey : ('campo_' + fKey);
      if (!sezioneLocale.value.campi[newKey]) {
        sezioneLocale.value.campi[newKey] = {
          label: fVal.label || fKey,
          tipo: 'file',
          obbligatorio: !!fVal.obbligatorio,
          tipoObbligo: fVal.obbligatorio ? 'assoluto' : 'nessuno',
          url: fVal.url || null,
          txt: fVal.url || '',
          ordine: maxOrder + offset
        };
        offset++;
      }
    }
    delete sezioneLocale.value.file;
  }

  // Auto-migrazione tipoObbligo sui campi esistenti
  if (sezioneLocale.value.campi) {
    for (const c of Object.values(sezioneLocale.value.campi)) {
      if (!c.tipoObbligo) {
        c.tipoObbligo = c.obbligatorio ? 'assoluto' : 'nessuno';
      }
    }
    normalizzaTipiObbligo();
  }
}, { deep: true, immediate: true });
</script>

<style scoped>
</style>
